/**
 * Global constants
 * - Move here if a localized constant needs to be accessible from multiple directories
 *   > Example: Component constants needs to be shared in /utils
 * - Create a specific file for the consts
 *   > Example: /components/layout/definitions/constants.ts => /definitions/constants/layout.ts
 * - Export all definitions from this file
 *   > Example: export * from './layout.ts';
 */

export const APPLICATION_KEY = 'one-support-center';

export * from './pagination';
export * from './search';
export * from './time';
export * from './trackingDetails';
export * from './user';
export * from './idConsole';
export * from './featureflags';
